import { render, staticRenderFns } from "./RecebtBlogPost1.vue?vue&type=template&id=0ffdf223&scoped=true&"
import script from "./RecebtBlogPost1.vue?vue&type=script&lang=js&"
export * from "./RecebtBlogPost1.vue?vue&type=script&lang=js&"
import style0 from "./RecebtBlogPost1.vue?vue&type=style&index=0&id=0ffdf223&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffdf223",
  null
  
)

export default component.exports